// Parser simples de vCard (RFC 6350), suficiente para o que o WhatsApp envia
// em contactMessage/contactsArrayMessage: nome (FN) e telefone(s) (TEL).
// Não é um parser genérico — cobre só os campos usados na pré-visualização
// de contato compartilhado no chat.

const digitsOnly = (str) => (str || "").replace(/\D/g, "");

// Recebe o texto bruto de UM vCard (BEGIN:VCARD ... END:VCARD) e retorna
// { name, numbers: [{ raw, display }] } ou null se não conseguir extrair nada.
export const parseVcard = (vcardText) => {
  if (!vcardText) return null;

  const lines = vcardText.split(/\r?\n/);
  let name = "";
  const numbers = [];

  lines.forEach((line) => {
    const colonIndex = line.indexOf(":");
    if (colonIndex === -1) return;

    const key = line.slice(0, colonIndex);
    const value = line.slice(colonIndex + 1).trim();

    if (key === "FN" || key.startsWith("FN;")) {
      name = value;
    } else if (/^TEL/i.test(key)) {
      // O WhatsApp costuma incluir "waid=<dígitos>" nos parâmetros do campo
      // (ex.: "TEL;type=CELL;waid=553194170017:+55 31 99417-0017"), que já
      // vem no formato E.164 sem símbolos — ideal para montar o link do wa.me.
      const waidMatch = key.match(/waid=(\d+)/i);
      const raw = waidMatch ? waidMatch[1] : digitsOnly(value);
      if (raw) numbers.push({ raw, display: value || raw });
    }
  });

  if (!name && numbers.length === 0) return null;

  return { name: name || "Contato", numbers };
};

// Recebe um JSON.stringify de um array de vCards (contactsArrayMessage) e
// retorna a lista já parseada, ignorando entradas inválidas.
export const parseVcardsArray = (jsonText) => {
  if (!jsonText) return [];
  try {
    const arr = JSON.parse(jsonText);
    if (!Array.isArray(arr)) return [];
    return arr.map(parseVcard).filter(Boolean);
  } catch (err) {
    return [];
  }
};

export const waLinkFor = (rawNumber) => {
  const digits = digitsOnly(rawNumber);
  return digits ? `https://wa.me/${digits}` : null;
};
